/*
 * GRIG home 2, S3 shoppable image behaviour (sections/grig-home-hotspots.liquid). Loaded only by that section, before
 * assets/grig-home.js, so it registers through the foundation queue (window.GRIGHomeReady) and runs again after
 * shopify:section:load; the returned cleanup runs on shopify:section:unload.
 * Port of NaturLabs MAIN assets/nl-w2-hotspots.js.
 *
 *   [data-gh-section="hotspots"]
 *     [data-ghs-point="n"] > button[data-ghs-dot][aria-controls][aria-expanded] + [data-ghs-pop] (hidden)
 *     [data-ghs-item="n"]  numbered list rows (highlight sync with the dots)
 *     dialog[data-ghs-sheet] with [data-ghs-sheet-body] and [data-ghs-close] (phones)
 *
 * Disclosure pattern, one popover open at a time. From 768 px the popover opens next to the dot (side chosen in
 * Liquid); Escape or an outside click closes it and focus returns to the dot; tabbing out of the point closes it.
 * Under 768 px the dot opens the bottom sheet (native modal dialog: focus stays inside, page scroll locked) with a
 * clone of the popover content; quick add inside keeps working through the foundation [data-gh-add] handler and the
 * cart drawer replaces the sheet. Theme editor: selecting a hotspot block opens it, deselecting closes it.
 */
(function () {
  'use strict';

  if (window.GRIGHomeHotspots) return;
  window.GRIGHomeHotspots = { version: '1.0.0' };

  var mqPhone = window.matchMedia('(max-width: 767px)');
  var LOCK_CLASS = 'ghs-lock';

  function init(root) {
    var points = Array.prototype.slice.call(root.querySelectorAll('[data-ghs-point]'));
    if (!points.length) return undefined;

    var sheet = root.querySelector('[data-ghs-sheet]');
    var sheetBody = sheet ? sheet.querySelector('[data-ghs-sheet-body]') : null;
    var canSheet = Boolean(sheet && sheetBody && typeof sheet.showModal === 'function');
    var open = null;
    var sheetPoint = null;
    var closingForCart = false;
    var off = [];

    function on(target, type, handler, options) {
      target.addEventListener(type, handler, options);
      off.push(function () { target.removeEventListener(type, handler, options); });
    }

    function dotOf(point) {
      return point.querySelector('[data-ghs-dot]');
    }

    function popOf(point) {
      return point.querySelector('[data-ghs-pop]');
    }

    function highlight(id, state) {
      if (!id) return;
      var point = root.querySelector('[data-ghs-point="' + id + '"]');
      var item = root.querySelector('[data-ghs-item="' + id + '"]');
      if (point) point.toggleAttribute('data-highlight', state);
      if (item) {
        item.toggleAttribute('data-highlight', state);
        var mini = item.querySelector('.gh-mini');
        if (mini) mini.classList.toggle('is-highlighted', state);
      }
    }

    function close() {
      var point = open;
      if (!point) return;
      var dot = dotOf(point);
      var pop = popOf(point);
      if (pop) pop.hidden = true;
      if (dot) dot.setAttribute('aria-expanded', 'false');
      point.removeAttribute('data-open');
      open = null;
    }

    function show(point) {
      close();
      var dot = dotOf(point);
      var pop = popOf(point);
      if (!dot || !pop) return;
      pop.hidden = false;
      point.setAttribute('data-open', '');
      dot.setAttribute('aria-expanded', 'true');
      open = point;
    }

    function openSheet(point) {
      var pop = popOf(point);
      var dot = dotOf(point);
      if (!pop || !canSheet) return false;
      close();
      var fragment = document.createDocumentFragment();
      Array.prototype.forEach.call(pop.childNodes, function (node) { fragment.appendChild(node.cloneNode(true)); });
      sheetBody.replaceChildren(fragment);
      sheetPoint = point;
      if (dot) dot.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add(LOCK_CLASS);
      if (!sheet.open) sheet.showModal();
      var closeButton = sheet.querySelector('[data-ghs-close]');
      if (closeButton) closeButton.focus({ preventScroll: true });
      return true;
    }

    function closeSheet() {
      if (sheet && sheet.open) sheet.close();
    }

    function toggle(point) {
      if (mqPhone.matches && canSheet) {
        openSheet(point);
        return;
      }
      if (open === point) close();
      else show(point);
    }

    points.forEach(function (point) {
      var dot = dotOf(point);
      if (!dot) return;
      var id = point.getAttribute('data-ghs-point');
      on(dot, 'click', function (event) {
        event.preventDefault();
        toggle(point);
      });
      on(point, 'pointerenter', function () { highlight(id, true); });
      on(point, 'pointerleave', function () { highlight(id, false); });
      on(dot, 'focus', function () { highlight(id, true); });
      on(dot, 'blur', function () { highlight(id, false); });
      // Tabbing past the popover closes it, focus is never trapped in a non modal popover
      on(point, 'focusout', function (event) {
        if (open === point && event.relatedTarget && !point.contains(event.relatedTarget)) close();
      });
    });

    Array.prototype.forEach.call(root.querySelectorAll('[data-ghs-item]'), function (item) {
      var id = item.getAttribute('data-ghs-item');
      on(item, 'pointerenter', function () { highlight(id, true); });
      on(item, 'pointerleave', function () { highlight(id, false); });
      on(item, 'focusin', function () { highlight(id, true); });
      on(item, 'focusout', function (event) {
        if (!event.relatedTarget || !item.contains(event.relatedTarget)) highlight(id, false);
      });
    });

    on(document, 'keydown', function (event) {
      if (event.key !== 'Escape' || !open) return;
      var dot = dotOf(open);
      close();
      if (dot) dot.focus();
    });

    on(document, 'click', function (event) {
      if (!open || open.contains(event.target)) return;
      close();
    });

    if (canSheet) {
      on(sheet, 'close', function () {
        document.documentElement.classList.remove(LOCK_CLASS);
        var point = sheetPoint;
        sheetPoint = null;
        if (!point) return;
        var dot = dotOf(point);
        if (dot) {
          dot.setAttribute('aria-expanded', 'false');
          if (!closingForCart) dot.focus({ preventScroll: true });
        }
        closingForCart = false;
      });
      // Click on the backdrop (the dialog box itself, outside the inner panel) closes the sheet
      on(sheet, 'click', function (event) {
        if (event.target === sheet) closeSheet();
      });
      Array.prototype.forEach.call(sheet.querySelectorAll('[data-ghs-close]'), function (button) {
        on(button, 'click', closeSheet);
      });
      // The cart drawer replaces the sheet: grig.js asks the sheet to give way before it opens the drawer
      on(sheet, 'grig:yield-to-cart', function () { closingForCart = true; });
      // The cart drawer opens after a successful add and replaces the sheet
      on(document, 'grig:cart-added', function () {
        if (!sheet.open) return;
        closingForCart = true;
        closeSheet();
      });
    }

    var onBreakpoint = function () {
      close();
      closeSheet();
    };
    if (mqPhone.addEventListener) {
      mqPhone.addEventListener('change', onBreakpoint);
      off.push(function () { mqPhone.removeEventListener('change', onBreakpoint); });
    }

    on(root, 'shopify:block:select', function (event) {
      var point = event.target && event.target.closest ? event.target.closest('[data-ghs-point]') : null;
      if (point && point !== open && !mqPhone.matches) show(point);
    });
    on(root, 'shopify:block:deselect', close);

    root.setAttribute('data-ghs-ready', '');

    return function cleanup() {
      close();
      closeSheet();
      document.documentElement.classList.remove(LOCK_CLASS);
      off.forEach(function (fn) { fn(); });
      off = [];
      root.removeAttribute('data-ghs-ready');
    };
  }

  window.GRIGHomeHotspots.init = init;

  (window.GRIGHomeReady = window.GRIGHomeReady || []).push(function (GH) {
    GH.register('hotspots', init);
  });
})();
